/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */
import { createAction } from '@modules/app/createAction';

import {
    IWizardAdditionalReportsValidateFinishPayload,
    TWizardAdditionalReportsHandleNextAction,
    TWizardAdditionalReportsSetParamsAction,
    TWizardAdditionalReportsSetParamsPayload,
    TWizardAdditionalReportsValidateFinishAction,
    TWizardAdditionalReportsValidateStartAction,
} from './types/wizardAdditionalReportsActionTypes';
import {
    WIZARD_ADDITIONAL_REPORTS_HANDLE_NEXT,
    WIZARD_ADDITIONAL_REPORTS_SET_PARAMS,
    WIZARD_ADDITIONAL_REPORTS_VALIDATE_FINISH,
    WIZARD_ADDITIONAL_REPORTS_VALIDATE_START,
} from './wizardAdditionalReportsConsant';

/*
* -------------------------------------------
*           VALIDATE
* -------------------------------------------
*/
export const wizardAdditionalReportsValidateStartAction = (): TWizardAdditionalReportsValidateStartAction =>
    createAction(WIZARD_ADDITIONAL_REPORTS_VALIDATE_START);

export const wizardAdditionalReportsValidateFinishAction = (payload: IWizardAdditionalReportsValidateFinishPayload):
    TWizardAdditionalReportsValidateFinishAction =>
    createAction(WIZARD_ADDITIONAL_REPORTS_VALIDATE_FINISH, payload);

/*
* -------------------------------------------
*           SET PARAMS
* -------------------------------------------
*/

export const wizardAdditionalReportsSetParamsAction = (payload: TWizardAdditionalReportsSetParamsPayload):
    TWizardAdditionalReportsSetParamsAction =>
    createAction(WIZARD_ADDITIONAL_REPORTS_SET_PARAMS, payload);

/*
* -------------------------------------------
*               NEXT
* -------------------------------------------
*/

export const wizardAdditionalReportsHandleNextAction = (): TWizardAdditionalReportsHandleNextAction =>
    createAction(WIZARD_ADDITIONAL_REPORTS_HANDLE_NEXT);
